import React from "react"
import { TABLE_OPERATION_TYPE } from "types/ReportingDashboard/elements.types"

interface BuilderOperationToggleProps {
  value: TABLE_OPERATION_TYPE
  onChange: (op: TABLE_OPERATION_TYPE) => void
}

const OPTIONS: { value: TABLE_OPERATION_TYPE; label: string; hint: string }[] =
  [
    {
      value: TABLE_OPERATION_TYPE.XTAB,
      label: "XTAB",
      hint: "Cross-tabulation (categorical)",
    },
    {
      value: TABLE_OPERATION_TYPE.DTAB,
      label: "DTAB",
      hint: "Data-tabulation (numeric)",
    },
  ]

/**
 * Two-segment XTAB/DTAB toggle. Drives which statistic options the
 * BuilderStatsRow renders.
 */
const BuilderOperationToggle: React.FC<BuilderOperationToggleProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="dq-btn-group" role="radiogroup" aria-label="Operation type">
      {OPTIONS.map((opt) => {
        const isActive = opt.value === value
        return (
          <button
            key={opt.value}
            type="button"
            className="dq-btn"
            data-active={isActive}
            role="radio"
            aria-checked={isActive}
            title={opt.hint}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}

export default BuilderOperationToggle
